import { useEffect, useState } from "react";

const localStorageKey = "soapbox:android-app";

const getInitialValue = () => {
  const value = localStorage.getItem(localStorageKey);

  if (!value) {
    return false;
  }

  return value === "1";
};

const useAndroidAppDetection = () => {
  const [isAndroid, setAndroid] = useState<boolean>(() => getInitialValue());

  const cacheAndroidState = () => {
    if (localStorage.getItem(localStorageKey) === "1") {
      return;
    }

    // Check to see if we are sideloading via APK or opening
    // from Play Store.
    const params = new URLSearchParams(window.location.search);
    const isSideloading = params.get("installation") === "apk";
    const hasAndroidReferrer = document.referrer.includes("android-app://");

    const value = hasAndroidReferrer && !isSideloading ? "1" : "0";
    localStorage.setItem(localStorageKey, value);
    setAndroid(value === "1");
  };

  useEffect(() => {
    cacheAndroidState();
  }, []);

  return isAndroid;
};

export { useAndroidAppDetection };
